// extracted by mini-css-extract-plugin
module.exports =  {"body":"a10a3f92e9--body--DP451","media":"a10a3f92e9--media--lUV2m","actions":"a10a3f92e9--actions--fcf6k"};